import React, { useState } from 'react';
import { Facebook, Instagram, Youtube, Linkedin, XIcon } from 'lucide-react';
import { ValuanLogo } from './ValuanLogo';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-[#1F46D5] text-white pt-16 pb-8 px-6 md:px-12" data-id="element-45">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-46">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-47">
            <div className="mb-6" data-id="element-48">
              <ValuanLogo variant="small" theme="dark" data-id="element-49" />
            </div>
            <div className="flex gap-3" data-id="element-50">
              <div className="bg-white/5 rounded-lg px-3 py-2 flex items-center gap-2 border border-white/10" data-id="element-51">
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor" data-id="element-52">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" data-id="element-53" />
                </svg>
                <div className="text-[10px] leading-tight" data-id="element-54">
                  <div className="opacity-70" data-id="element-55">Disponible en</div>
                  <div className="font-semibold" data-id="element-56">App Store</div>
                </div>
              </div>
              <div className="bg-white/5 rounded-lg px-3 py-2 flex items-center gap-2 border border-white/10" data-id="element-57">
                <img src="https://cdn.magicpatterns.com/uploads/unSXeVS1XDVkLaqUojQEhc/logotipo-tienda-google-play_1273375-804.png" alt="Google Play" className="w-4 h-4 object-contain" data-id="element-58" />
                <div className="text-[10px] leading-tight" data-id="element-59">
                  <div className="opacity-70" data-id="element-60">Descárgala en</div>
                  <div className="font-semibold" data-id="element-61">Google Play</div>
                </div>
              </div>
            </div>
          </div>

          {/* Contacto */}
          <div data-id="element-62">
            <h4 className="font-display font-medium mb-4 text-sm" data-id="element-63">Contacto</h4>
            <ul className="space-y-3 text-sm text-white/70 font-light" data-id="element-64">
              <li data-id="element-65">(+52) 55 1136 2283</li>
              <li data-id="element-66">contacto@valuancrm.com</li>
              <li data-id="element-67"></li>
            </ul>
          </div>

          {/* Recursos */}
          <div data-id="element-68">
            <h4 className="font-display font-medium mb-4 text-sm" data-id="element-69">Recursos</h4>
            <ul className="space-y-3 text-sm text-white/70 font-light" data-id="element-70">
              <li data-id="element-71">
                <a href="https://demo.valuancrm.com/video" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-72">
                  Tutoriales de Inicio
                </a>
              </li>
              <li data-id="element-73">
                <a href="https://api.whatsapp.com/send?phone=525511362283&text=Quiero ser afiliado de Valuan CRM, Vi su información en el sitio web" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-74">
                  Afiliados
                </a>
              </li>
              <li data-id="element-75">
                <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors text-left" data-id="element-76">
                  Términos y Condiciones
                </button>
              </li>
              <li data-id="element-77">
                <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors text-left" data-id="element-78">
                  Política de Privacidad
                </button>
              </li>
            </ul>
          </div>

          {/* Redes Sociales */}
          <div data-id="element-79">
            <h4 className="font-display font-medium mb-4 text-sm" data-id="element-80">
              Redes Sociales
            </h4>
            <div className="flex gap-4" data-id="element-81">
              <a href="https://www.facebook.com/valuancrm" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" data-id="element-82">
                <Facebook className="w-5 h-5" data-id="element-83" />
              </a>
              <a href="https://www.instagram.com/valuancrm" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" data-id="element-84">
                <Instagram className="w-5 h-5" data-id="element-85" />
              </a>
              <a href="https://www.youtube.com/channel/UCmoaJUqbz1F0X6MDds_TioA?sub_confirmation=1" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" data-id="element-86">
                <Youtube className="w-5 h-5" data-id="element-87" />
              </a>
              <a href="https://www.linkedin.com/in/valuancrm/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" data-id="element-88">
                <Linkedin className="w-5 h-5" data-id="element-89" />
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto pt-8 border-t border-white/10 text-center text-sm text-white/50 font-light" data-id="element-90">
          © {new Date().getFullYear()} Valuan CRM. Todos los derechos
          reservados.
        </div>
      </footer>

      {/* Terms & Conditions Modal */}
      {showTerms && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => setShowTerms(false)} data-id="element-91">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-92">
            <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl" data-id="element-93">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-94">
                Términos y Condiciones
              </h2>
              <button onClick={() => setShowTerms(false)} className="text-gray-400 hover:text-gray-700 transition-colors" data-id="element-95">
                <XIcon className="w-5 h-5" data-id="element-96" />
              </button>
            </div>
            <div className="px-8 py-6 text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-97">
              <p className="text-xs text-gray-400" data-id="element-98">
                Última actualización: Abril 2026
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-99">
                1. Aceptación de los Términos
              </h3>
              <p data-id="element-100">
                Al acceder y utilizar la plataforma Valuan CRM, usted acepta
                estar sujeto a estos Términos y Condiciones. Si no está de
                acuerdo con alguno de estos términos, le solicitamos no utilizar
                nuestros servicios.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-101">
                2. Descripción del Servicio
              </h3>
              <p data-id="element-102">
                Valuan CRM es una plataforma de gestión de relaciones con
                clientes (CRM) que ofrece herramientas de marketing, ventas,
                automatización y comunicación centralizada para negocios y
                agencias.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-103">
                3. Registro y Cuenta
              </h3>
              <p data-id="element-104">
                Para utilizar Valuan CRM, debe crear una cuenta proporcionando
                información veraz y actualizada. Usted es responsable de
                mantener la confidencialidad de sus credenciales de acceso y de
                todas las actividades que ocurran bajo su cuenta.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-105">
                4. Uso Aceptable
              </h3>
              <p data-id="element-106">
                Usted se compromete a utilizar Valuan CRM únicamente para fines
                legales y de acuerdo con estos términos. Queda prohibido el uso
                de la plataforma para enviar spam, contenido ilegal o cualquier
                actividad que viole las leyes aplicables.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-107">
                5. Pagos y Suscripciones
              </h3>
              <p data-id="element-108">
                Los planes de suscripción se facturan de acuerdo con el periodo
                seleccionado. Los pagos no son reembolsables salvo lo
                establecido en nuestra política de reembolsos. Nos reservamos el
                derecho de modificar los precios con previo aviso de 30 días.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-109">
                6. Propiedad Intelectual
              </h3>
              <p data-id="element-110">
                Todo el contenido, diseño, logotipos y software de Valuan CRM
                son propiedad exclusiva de Valuan y están protegidos por las
                leyes de propiedad intelectual aplicables.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-111">
                7. Protección de Datos
              </h3>
              <p data-id="element-112">
                Nos comprometemos a proteger sus datos personales de acuerdo con
                nuestra Política de Privacidad y las leyes de protección de
                datos aplicables en México, incluyendo la Ley Federal de
                Protección de Datos Personales en Posesión de los Particulares.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-113">
                8. Limitación de Responsabilidad
              </h3>
              <p data-id="element-114">
                Valuan CRM se proporciona "tal cual". No garantizamos que el
                servicio sea ininterrumpido o libre de errores. En ningún caso
                seremos responsables por daños indirectos, incidentales o
                consecuentes derivados del uso de la plataforma.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-115">
                9. Modificaciones
              </h3>
              <p data-id="element-116">
                Nos reservamos el derecho de modificar estos Términos y
                Condiciones en cualquier momento. Las modificaciones entrarán en
                vigor al ser publicadas en nuestro sitio web. El uso continuado
                de la plataforma constituye la aceptación de los términos
                modificados.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-117">
                10. Contacto
              </h3>
              <p data-id="element-118">
                Para cualquier consulta relacionada con estos términos, puede
                contactarnos en{' '}
                <a href="mailto:contacto@valuancrm.com" className="text-[#1F46D5] hover:underline" data-id="element-119">
                  contacto@valuancrm.com
                </a>{' '}
                o al teléfono (+52) 55 1136 2283.
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Policy Modal */}
      {showPrivacy && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => setShowPrivacy(false)} data-id="element-120">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-121">
            <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl" data-id="element-122">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-123">
                Política de Privacidad
              </h2>
              <button onClick={() => setShowPrivacy(false)} className="text-gray-400 hover:text-gray-700 transition-colors" data-id="element-124">
                <XIcon className="w-5 h-5" data-id="element-125" />
              </button>
            </div>
            <div className="px-8 py-6 text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-126">
              <p className="text-xs text-gray-400" data-id="element-127">
                Última actualización: Abril 2026
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-128">
                1. Responsable del Tratamiento
              </h3>
              <p data-id="element-129">
                Valuan CRM, con domicilio en Querétaro, México, es responsable
                del tratamiento de sus datos personales. Para cualquier consulta
                sobre esta política, puede contactarnos en
                contacto@valuancrm.com o al teléfono (+52) 55 1136 2283.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-130">
                2. Datos Personales Recopilados
              </h3>
              <p data-id="element-131">
                Recopilamos los siguientes datos personales: nombre completo,
                correo electrónico, número telefónico, nombre de la empresa,
                información de facturación, dirección IP y datos de uso de la
                plataforma.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-132">
                3. Finalidades del Tratamiento
              </h3>
              <p data-id="element-133">
                Sus datos personales serán utilizados para: proveer y
                administrar los servicios contratados, procesar pagos y
                facturación, enviar comunicaciones relacionadas con el servicio,
                mejorar la experiencia del usuario, cumplir con obligaciones
                legales y, con su consentimiento, enviar información
                promocional.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-134">
                4. Protección de Datos
              </h3>
              <p data-id="element-135">
                Implementamos medidas de seguridad técnicas, administrativas y
                físicas para proteger sus datos personales contra daño, pérdida,
                alteración, destrucción o uso no autorizado. Utilizamos cifrado
                SSL/TLS para la transmisión de datos y almacenamiento seguro en
                servidores protegidos.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-136">
                5. Compartición de Datos
              </h3>
              <p data-id="element-137">
                No vendemos ni compartimos sus datos personales con terceros,
                excepto cuando sea necesario para: proveedores de servicios
                esenciales (procesadores de pago, servicios de hosting),
                cumplimiento de obligaciones legales, o con su consentimiento
                expreso.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-138">
                6. Derechos ARCO
              </h3>
              <p data-id="element-139">
                Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse
                al tratamiento de sus datos personales (derechos ARCO). Para
                ejercer estos derechos, envíe una solicitud a
                contacto@valuancrm.com con su nombre completo, descripción del
                derecho que desea ejercer y documentación que acredite su
                identidad.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-140">
                7. Cookies y Tecnologías de Rastreo
              </h3>
              <p data-id="element-141">
                Utilizamos cookies y tecnologías similares para mejorar su
                experiencia en la plataforma, analizar el uso del servicio y
                personalizar contenido. Puede configurar su navegador para
                rechazar cookies, aunque esto podría afectar la funcionalidad
                del servicio.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-142">
                8. Retención de Datos
              </h3>
              <p data-id="element-143">
                Conservamos sus datos personales durante el tiempo que mantenga
                una cuenta activa y por el periodo adicional que requieran las
                obligaciones legales aplicables. Una vez cumplido este periodo,
                sus datos serán eliminados de forma segura.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-144">
                9. Modificaciones a esta Política
              </h3>
              <p data-id="element-145">
                Nos reservamos el derecho de actualizar esta Política de
                Privacidad. Cualquier cambio será notificado a través de la
                plataforma o por correo electrónico. Le recomendamos revisar
                esta política periódicamente.
              </p>

              <h3 className="font-semibold text-gray-900 text-base" data-id="element-146">
                10. Contacto
              </h3>
              <p data-id="element-147">
                Para cualquier duda o solicitud relacionada con esta política,
                contáctenos en{' '}
                <a href="mailto:contacto@valuancrm.com" className="text-[#1F46D5] hover:underline" data-id="element-148">
                  contacto@valuancrm.com
                </a>{' '}
                o al teléfono (+52) 55 1136 2283.
              </p>
            </div>
          </div>
        </div>}
    </>;
}